import { useQueryClient } from "@tanstack/react-query";

import { workforceKeys } from "./query_keys";

export const useWorkforceInvalidate = () => {
  const queryClient = useQueryClient();
  return {
    invalidate: () => queryClient.invalidateQueries({ queryKey: workforceKeys.all() }),
    removeCache: () => queryClient.removeQueries({ queryKey: workforceKeys.all() })
  };
};
